import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { EndSessionComponent } from '../../shared/endSession/end-session.component';

/**
 * Service used to open End session dialog
 */
@Injectable({ providedIn: 'root' })
export class EndSessionModalService {
  private isOpen = false;

  constructor(private readonly modalService: NgbModal) { }

  /**
   * Opens End Session Component.
   * Controls whether the component is already opened. Closes the component when modal is closed.
   */
  open(): void {
    if (this.isOpen) {
      return;
    }
    this.isOpen = true;
    const modalRef: NgbModalRef = this.modalService.open(EndSessionComponent, { size: 'lg' });
    modalRef.result.finally(() => (this.isOpen = false));
  }
}
